/* ============================================================
   Choco Crystal — product-form.js
   Variant selection (price/availability) + product gallery
   + swipe + lightbox (pelny podglad zdjecia).
   Re-initialises on shopify:section:load for the theme editor.
   ============================================================ */
(function () {
  'use strict';

  function initProductForm(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.dataset.ccBound) return;
      form.dataset.ccBound = '1';

      var variantsData = form.querySelector('[data-variants-json]');
      var variants = [];
      try { variants = JSON.parse(variantsData ? variantsData.textContent : '[]'); } catch (e) {}
      var idInput = form.querySelector('[data-variant-id]');
      var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-option]'));
      var priceTarget = document.querySelector('[data-product-price]');
      var submitBtn = form.querySelector('[type="submit"]');

      function currentOptions() { return selects.map(function (s) { return s.value; }); }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update() {
        if (!variants.length) return;
        var variant = selects.length ? findVariant(currentOptions()) : variants[0];
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.getAttribute('data-unavailable') || 'Niedostępny'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceTarget && variant.price_html) priceTarget.innerHTML = variant.price_html;
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (submitBtn.getAttribute('data-add-label') || 'Dodaj do koszyka')
            : (submitBtn.getAttribute('data-soldout-label') || 'Wyprzedane');
        }
        if (history.replaceState && variant.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  /* ------------------------------------------------------------
     Zbiera adresy zdjec z miniatur. Sekcja main-product.liquid
     renderuje tylko JEDNO duze zdjecie, a pozostale adresy siedza
     w atrybutach data-full miniatur - dlatego i tor slajdow,
     i lightbox budujemy z tych wlasnie atrybutow. Sekcji nie
     trzeba ruszac (a tym samym nie ryzykujemy jej bloku schema).
     ------------------------------------------------------------ */
  function collectShots(thumbs) {
    return thumbs.map(function (t) {
      return { src: t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' };
    }).filter(function (s) { return !!s.src; });
  }

  /* ------------------------------------------------------------
     Lightbox - pelny podglad. Budowany leniwie, przy pierwszym
     kliknieciu, zeby nie wczytywac duzych plikow na zapas.
     Przesuwanie w srodku tez jest natywnym scroll-snapem.
     ------------------------------------------------------------ */
  function createLightbox(shots) {
    var box = null;
    var track = null;

    function hide() {
      if (!box) return;
      box.setAttribute('hidden', '');
      document.documentElement.classList.remove('cc-lightbox-open');
    }

    function build() {
      box = document.createElement('div');
      box.className = 'cc-lightbox';
      box.setAttribute('hidden', '');

      track = document.createElement('div');
      track.className = 'cc-lightbox__track';

      shots.forEach(function (shot) {
        var slide = document.createElement('div');
        slide.className = 'cc-lightbox__slide';
        var img = document.createElement('img');
        img.setAttribute('src', shot.src);
        img.setAttribute('alt', shot.alt);
        img.setAttribute('draggable', 'false');
        slide.appendChild(img);
        track.appendChild(slide);
      });

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'cc-lightbox__close';
      close.setAttribute('aria-label', 'Zamknij');
      close.innerHTML = '&times;';

      box.appendChild(track);
      box.appendChild(close);
      document.body.appendChild(box);

      close.addEventListener('click', hide);

      // klik w tlo (ale nie w samo zdjecie) zamyka
      box.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG' && e.target !== close) hide();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') hide();
      });
    }

    function show(i) {
      if (!box) build();
      box.removeAttribute('hidden');
      document.documentElement.classList.add('cc-lightbox-open');
      // scrollLeft dopiero po tym, jak przegladarka policzy layout
      requestAnimationFrame(function () {
        if (track.clientWidth) track.scrollLeft = i * track.clientWidth;
      });
    }

    return { show: show, hide: hide };
  }

  /* ------------------------------------------------------------
     Galeria produktu - swipe zamiast klikania w miniatury.

     Sam przesuw jest NATYWNY: tor ma CSS scroll-snap, wiec zadnych
     touchstart/touchmove nie obslugujemy. To odporniejsze od wlasnej
     obslugi gestow i nie blokuje pionowego scrollowania strony.

     JS synchronizuje tylko dwie strony:
       klik w miniature   -> przewin tor do tego slajdu
       przewiniecie toru  -> podswietl odpowiednia miniature
     plus otwiera lightbox na klik w zdjecie.

     Kazdy slajd ma szerokosc 100% toru, wiec indeks slajdu to
     po prostu scrollLeft / clientWidth.
     ------------------------------------------------------------ */
  function buildTrack(gallery, shots) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return null;

    var existing = gallery.querySelector('[data-gallery-track]');
    if (existing) return existing;

    var firstImg = main.querySelector('img');
    var track = document.createElement('div');
    track.className = 'cc-gallery__track';
    track.setAttribute('data-gallery-track', '');

    shots.forEach(function (shot, i) {
      var slide = document.createElement('div');
      slide.className = 'cc-gallery__slide';
      slide.setAttribute('data-gallery-slide', '');

      var img = document.createElement('img');
      if (i === 0 && firstImg) {
        // pierwszy slajd: bierzemy juz wczytany obrazek, zeby nie mignelo
        img.setAttribute('src', firstImg.getAttribute('src'));
        img.setAttribute('alt', firstImg.getAttribute('alt') || '');
        img.setAttribute('loading', 'eager');
      } else {
        img.setAttribute('src', shot.src);
        img.setAttribute('alt', shot.alt);
        img.setAttribute('loading', 'lazy');
      }
      img.setAttribute('draggable', 'false');

      slide.appendChild(img);
      track.appendChild(slide);
    });

    if (!track.children.length) return null;

    main.textContent = '';
    main.appendChild(track);
    return track;
  }

  function initGallery(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ccBound) return;
      gallery.dataset.ccBound = '1';

      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      var shots = collectShots(thumbs);

      // jedno zdjecie: nie ma czego przesuwac, ale podglad i tak dajemy
      if (shots.length < 2) {
        var lone = gallery.querySelector('[data-gallery-main] img');
        if (lone) {
          var lbOne = createLightbox([{ src: lone.getAttribute('src'), alt: lone.getAttribute('alt') || '' }]);
          lone.style.cursor = 'zoom-in';
          lone.addEventListener('click', function () { lbOne.show(0); });
        }
        return;
      }

      var track = buildTrack(gallery, shots);
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
      var lb = createLightbox(shots);

      function currentIndex() {
        if (!track.clientWidth) return 0;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        return i;
      }

      function setActive(i) {
        thumbs.forEach(function (t, j) {
          if (i === j) { t.classList.add('is-active'); } else { t.classList.remove('is-active'); }
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          setActive(i);
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          setActive(currentIndex());
        });
      }, { passive: true });

      /* Klik otwiera podglad, ale NIE wtedy, gdy to byl swipe:
         zapamietujemy X przy pointerdown i jesli palec przejechal
         wiecej niz 10 px, traktujemy to jako przesuwanie, nie klik. */
      var downX = null;
      var dragged = false;

      track.addEventListener('pointerdown', function (e) {
        downX = e.clientX;
        dragged = false;
      }, { passive: true });

      track.addEventListener('pointermove', function (e) {
        if (downX !== null && Math.abs(e.clientX - downX) > 10) dragged = true;
      }, { passive: true });

      track.addEventListener('click', function () {
        downX = null;
        if (dragged) { dragged = false; return; }
        lb.show(currentIndex());
      });

      setActive(0);
    });
  }

  function initAll(scope) { initProductForm(scope); initGallery(scope); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('cc:reinit', function (e) { initAll(e.detail && e.detail.target ? e.detail.target : document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
